import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Modal,
  OverlayTrigger,
  Tooltip,
  Panel,
  FormGroup,
  FormControl,
  ControlLabel,
  Form,
} from 'react-bootstrap'; // Adicionar Form

import ReactTableGT2A from '../common/grid/gridReactTable'; // Adaptar caminho se necessário
import Button from '../common/form/button';
import { toastr } from 'react-redux-toastr';
// import ContentHeader from '../common/template/contentHeader'; // Não usaremos mais aqui para ter mais controle

// TODO: Criar e importar as actions de ticketSuporteActions
import { fetchTickets, fetchInteracoes, addInteracao, updateTicket } from './ticketSuporteActions'; // Adicionar updateTicket
// TODO: Criar e importar o componente de formulário
import TicketSuporteForm from './ticketSuporteForm'; // Descomentado
import './ticketSuporte.css'; // Importando o CSS específico do módulo

// Estilo para os botões de filtro de status
const filterButtonStyle = {
  marginRight: '5px',
  marginBottom: '10px', // Adiciona espaço abaixo dos botões de filtro
};

class TicketSuporteList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // list: [], // Lista de tickets agora virá via Redux (this.props.tickets)
      showModal: false, // Para o formulário de novo/edição de ticket
      editingTicket: null, // Para popular o formulário em modo de edição
      loading: false,
      // Filtros
      statusFilter: 'TODOS', // Padrão para 'TODOS'
      showInteractionsModal: false, // Novo estado para o modal de interações
      currentTicketForInteractions: null, // Ticket selecionado para interações
      newInteractionText: '', // Estado para o texto da nova interação
      currentTicketInteractionsAdding: false, // Mapear novo estado
      currentTicketInteractionsAddError: null, // Mapear novo estado
      editingTicketStatus: '', // Para o status do ticket no modal de interações
      originalTicketStatus: '', // Para comparar se o status mudou
      isSavingStatus: false, // Para feedback no botão Salvar Status
    };
    this._isMounted = false; // Para controle de montagem do componente
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleStatusFilterChange = this.handleStatusFilterChange.bind(this);
    this.loadTickets = this.loadTickets.bind(this);
    this.handleShowInteractionsModal = this.handleShowInteractionsModal.bind(this);
    this.handleCloseInteractionsModal = this.handleCloseInteractionsModal.bind(this);
    this.handleNewInteractionChange = this.handleNewInteractionChange.bind(this);
    this.handleAddNewInteraction = this.handleAddNewInteraction.bind(this);
    this.handleEditingTicketStatusChange = this.handleEditingTicketStatusChange.bind(this);
    this.handleSaveTicketStatus = this.handleSaveTicketStatus.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.loadTickets(); // Carrega com o filtro padrão 'TODOS'
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  loadTickets() {
    if (!this._isMounted) return;
    this.setState({ loading: true });

    const { statusFilter } = this.state;
    let params = {}; // Parâmetros para a API

    if (statusFilter && statusFilter !== 'TODOS') {
      params.status = statusFilter; // Adiciona status ao params apenas se não for 'TODOS'
    }
    // Se statusFilter for 'TODOS', params continuará sendo {} (sem filtro de status)

    this.props
      .fetchTickets(params) // Envia o objeto params
      .catch(error => {
        if (this._isMounted) {
          toastr.error('Erro', 'Não foi possível carregar os tickets.');
          console.error('Erro ao buscar tickets:', error);
        }
      })
      .finally(() => {
        if (this._isMounted) {
          this.setState({ loading: false });
        }
      });
  }

  handleStatusFilterChange(newStatus) {
    // Atualiza o estado e chama loadTickets, que usará o novo statusFilter para montar os params
    this.setState({ statusFilter: newStatus }, this.loadTickets);
  }

  handleShowModal(ticket = null) {
    this.setState({ showModal: true, editingTicket: ticket });
  }

  handleCloseModal() {
    this.setState({ showModal: false, editingTicket: null });
    this.loadTickets(); // Recarrega os tickets após fechar o modal
  }

  handleShowInteractionsModal(ticket) {
    this.setState({
      showInteractionsModal: true,
      currentTicketForInteractions: ticket,
      newInteractionText: '',
      editingTicketStatus: ticket.status, // Inicializa o status para edição
      originalTicketStatus: ticket.status, // Guarda o status original
      isSavingStatus: false, // Reseta o estado de salvamento
    });
    this.props.fetchInteracoes(ticket.id);
  }

  handleCloseInteractionsModal() {
    this.setState({ showInteractionsModal: false, currentTicketForInteractions: null });
  }

  handleNewInteractionChange(event) {
    this.setState({ newInteractionText: event.target.value });
  }

  handleAddNewInteraction() {
    const { currentTicketForInteractions, newInteractionText } = this.state;
    if (!newInteractionText.trim()) {
      toastr.warning('Atenção', 'O texto da interação não pode estar vazio.');
      return;
    }

    const interacaoData = {
      texto_interacao: newInteractionText.trim(),
      // tipo_interacao: 'COMENTARIO', // Se quiser definir um tipo padrão
      // privado: false, // Se quiser definir um padrão de privacidade
    };

    this.props
      .addInteracao(currentTicketForInteractions.id, interacaoData)
      .then(() => {
        // Sucesso já tratado na action com toastr
        if (this._isMounted) {
          this.setState({ newInteractionText: '' }); // Limpa o campo após o envio
          // A lista de interações será atualizada pelo reducer.
          // Se não for, podemos chamar fetchInteracoes aqui:
          // this.props.fetchInteracoes(currentTicketForInteractions.id);
        }
      })
      .catch(error => {
        // Erro já tratado na action com toastr
        // Se precisar de tratamento adicional específico no componente, pode ser feito aqui.
        console.error('Falha ao adicionar interação (componente):', error);
      });
  }

  handleEditingTicketStatusChange(event) {
    this.setState({ editingTicketStatus: event.target.value });
  }

  handleSaveTicketStatus() {
    const { currentTicketForInteractions, editingTicketStatus } = this.state;
    if (!currentTicketForInteractions || !editingTicketStatus) return;

    this.setState({ isSavingStatus: true });

    const ticketDataToUpdate = {
      ...currentTicketForInteractions, // Envia todos os dados do ticket
      status: editingTicketStatus, // Apenas o status é alterado
    };

    this.props
      .updateTicket(ticketDataToUpdate)
      .then(() => {
        toastr.success('Sucesso', 'Status do ticket atualizado!');
        if (this._isMounted) {
          this.setState({ originalTicketStatus: editingTicketStatus, isSavingStatus: false });
          // Opcional: Se quiser fechar o modal após salvar o status
          // this.handleCloseInteractionsModal();
          // A lista de tickets principal será atualizada pelo Redux e pelo loadTickets no fechamento do form principal
        }
      })
      .catch(error => {
        toastr.error('Erro', 'Falha ao atualizar o status do ticket.');
        console.error('Erro ao salvar status do ticket:', error);
        if (this._isMounted) {
          this.setState({ isSavingStatus: false });
        }
      });
  }

  getStatusTicketClass(status) {
    switch (String(status).toUpperCase()) {
      case 'ABERTO':
        return 'status-ticket-aberto';
      case 'EM_ANDAMENTO':
        return 'status-ticket-em_andamento';
      case 'FINALIZADO':
        return 'status-ticket-finalizado';
      default:
        return 'status-ticket-unknown';
    }
  }

  getStatusControladorClass(statusCtrl) {
    switch (String(statusCtrl).toUpperCase()) {
      case 'ONLINE': // Supondo 'ONLINE' como um valor possível
        return 'status-ctrl-online';
      case 'OFFLINE':
        return 'status-ctrl-offline';
      default:
        return 'status-ctrl-unknown';
    }
  }

  getColumns() {
    const formatStatusDisplay = status => {
      if (!status) return '';
      switch (String(status).toUpperCase()) {
        case 'ABERTO':
          return 'Aberto';
        case 'EM_ANDAMENTO':
          return 'Em andamento';
        case 'FINALIZADO':
          return 'Finalizados';
        default:
          return status;
      }
    };

    return [
      // Coluna 'Usuário que assumiu' foi removida pela sua modificação anterior
      {
        Header: 'Controlador',
        accessor: 'controlador_numero',
        minWidth: 80,
        headerClassName: 'text-center',
        className: 'text-center',
      },
      {
        Header: 'Grupo Físico',
        accessor: 'grupo_fisico_id',
        minWidth: 80,
        headerClassName: 'text-center',
        className: 'text-center',
      },
      {
        Header: 'Erro',
        accessor: 'mensagem_erro',
        minWidth: 150,
      },
      {
        Header: 'Status Ticket',
        accessor: 'status',
        minWidth: 120,
        className: 'text-center',
        Cell: ({ value }) => (
          <span className={`status-badge ${this.getStatusTicketClass(value)}`}>{formatStatusDisplay(value)}</span>
        ),
      },
      {
        Header: 'Controlador Agora', // Como modificado por você
        accessor: 'situacao_atual_controlador',
        minWidth: 140,
        className: 'text-center',
        Cell: ({ value }) => (
          <span className={`status-badge ${this.getStatusControladorClass(value)}`}>{value || 'N/A'}</span>
        ),
      },
      {
        Header: 'Usuário que abriu',
        accessor: 'nome_usuario_abertura',
        minWidth: 130,
        headerClassName: 'text-center',
        className: 'text-center',
      },
      {
        Header: 'Atualização',
        accessor: 'data_ultima_atualizacao',
        minWidth: 140,
        className: 'text-center',
        Cell: ({ value }) => new Date(value).toLocaleString('pt-BR'),
      },
      {
        Header: 'Ações',
        accessor: 'id',
        width: 70, // Reduzir um pouco a largura, já que é só um botão
        headerClassName: 'text-center',
        className: 'text-center',
        Cell: ({ original: ticket }) => (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-interactions-${ticket.id}`}>Ver Interações</Tooltip>}
          >
            <Button
              className="btn btn-info btn-sm"
              icon="comments"
              onClick={() => this.handleShowInteractionsModal(ticket)}
            />
          </OverlayTrigger>
        ),
      },
    ];
  }

  renderStatusFilters() {
    const { statusFilter } = this.state;
    // Ordem dos status ajustada, com 'Todos' primeiro
    const statuses = [
      { value: 'TODOS', label: 'Todos' },
      { value: 'ABERTO', label: 'Abertos' },
      { value: 'EM_ANDAMENTO', label: 'Em Andamento' },
      { value: 'FINALIZADO', label: 'Finalizados' },
    ];

    return (
      <div className="btn-toolbar" role="toolbar" style={{ marginBottom: '20px' }}>
        <div className="btn-group" role="group">
          {statuses.map(s => (
            <Button
              key={s.value}
              style={filterButtonStyle}
              className={`btn ${statusFilter === s.value ? 'btn-primary active' : 'btn-default'}`}
              onClick={() => this.handleStatusFilterChange(s.value)} // Passa s.value diretamente
              label={s.label}
            />
          ))}
        </div>
      </div>
    );
  }

  render() {
    const {
      showModal,
      editingTicket,
      showInteractionsModal,
      currentTicketForInteractions,
      newInteractionText,
      currentTicketInteractionsAdding,
      currentTicketInteractionsAddError,
      editingTicketStatus,
      originalTicketStatus,
      isSavingStatus,
    } = this.state;
    const { tickets, interacoesDoTicketAtual, interacoesLoading, interacoesError } = this.props;
    const columns = this.getColumns();

    return (
      <div>
        <section className="content-header">
          <Row>
            <Col xs={8} md={9}>
              <h1 style={{ fontSize: '24px', marginTop: '0px', marginBottom: '5px' }}>
                Tickets de Suporte
                <small style={{ marginLeft: '8px', fontSize: '60%' }}>Gerenciamento de chamados</small>
              </h1>
            </Col>
            <Col xs={4} md={3} style={{ textAlign: 'right', paddingTop: '10px' }}>
              <Button
                className="btn btn-success"
                icon="plus"
                label="Novo Chamado"
                onClick={() => this.handleShowModal()}
                style={{ padding: '6px 12px' }}
              />
            </Col>
          </Row>
        </section>

        <section className="content">
          <div className="box box-primary" style={{ borderTopColor: '#3c8dbc' }}>
            <div className="box-body">
              {this.renderStatusFilters()}
              <ReactTableGT2A
                data={tickets || []}
                columns={columns}
                defaultPageSize={10}
                showPaginationTop={false}
                showPaginationBottom={true}
                sortable={true}
                loading={this.state.loading}
                noDataText={this.state.loading ? 'Carregando tickets...' : 'Nenhum ticket encontrado'}
                className="-striped -highlight" // Classes padrão do React Table para melhor visual
              />
            </div>
          </div>

          {/* Modal para o formulário de Ticket */}

          <TicketSuporteForm
            show={showModal}
            onHide={this.handleCloseModal}
            ticket={editingTicket}
            // Passar a action de salvar/criar será feito no TicketSuporteForm via mapDispatchToProps
          />

          {/* Placeholder para o futuro Modal de Interações */}
          {currentTicketForInteractions && (
            <Modal
              show={showInteractionsModal}
              onHide={this.handleCloseInteractionsModal}
              backdrop="static"
              keyboard={false}
              bsSize="large"
            >
              <Modal.Header closeButton style={{ backgroundColor: '#367fa9', color: 'white' }}>
                <Modal.Title>
                  <i className="fa fa-comments-o" /> Detalhes do Ticket #{currentTicketForInteractions.id}{' '}
                  <small style={{ color: '#f3f3f3' }}>- {currentTicketForInteractions.titulo}</small>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto', padding: '20px 25px' }}>
                <Panel bsStyle="info" defaultExpanded className="ticket-details-readonly-panel">
                  <Panel.Heading>
                    <Panel.Title toggle componentClass="h4" style={{ fontSize: '1.1em' }}>
                      Informações do Ticket
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body style={{ padding: '10px 15px' }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', marginBottom: '8px' }}>
                      <div
                        style={{ display: 'flex', alignItems: 'baseline', marginRight: '20px', marginBottom: '5px' }}
                      >
                        <span style={{ fontWeight: 'bold', marginRight: '5px' }}>Controlador ID:</span>
                        <span>{currentTicketForInteractions.controlador_id || 'N/A'}</span>
                      </div>
                      <div
                        style={{ display: 'flex', alignItems: 'baseline', marginRight: '20px', marginBottom: '5px' }}
                      >
                        <span style={{ fontWeight: 'bold', marginRight: '5px' }}>G. Físico ID:</span>
                        <span>{currentTicketForInteractions.grupo_fisico_id || 'N/A'}</span>
                      </div>
                      <div
                        style={{ display: 'flex', alignItems: 'baseline', marginRight: '20px', marginBottom: '5px' }}
                      >
                        <span style={{ fontWeight: 'bold', marginRight: '5px' }}>Erro Vinculado:</span>
                        <span>{currentTicketForInteractions.controlador_erro_id || 'N/A'}</span>
                      </div>
                    </div>

                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', marginBottom: '5px' }}>
                      <div
                        style={{ display: 'flex', alignItems: 'baseline', marginRight: '20px', marginBottom: '5px' }}
                      >
                        <span style={{ fontWeight: 'bold', marginRight: '5px' }}>Aberto por:</span>
                        <span>{currentTicketForInteractions.nome_usuario_abertura || 'N/A'}</span>
                      </div>
                      <div
                        style={{ display: 'flex', alignItems: 'baseline', marginRight: '20px', marginBottom: '5px' }}
                      >
                        <span style={{ fontWeight: 'bold', marginRight: '5px' }}>Data Abertura:</span>
                        <span>
                          {new Date(currentTicketForInteractions.data_abertura).toLocaleString('pt-BR', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                          })}
                        </span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px', marginBottom: '5px' }}>
                        <span style={{ fontWeight: 'bold', marginRight: '5px', color: '#337ab7' }}>Status:</span>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <FormControl
                            componentClass="select"
                            value={editingTicketStatus}
                            onChange={this.handleEditingTicketStatusChange}
                            style={{
                              flexGrow: 1,
                              marginRight: originalTicketStatus !== editingTicketStatus ? '8px' : '0',
                              height: '28px',
                              fontSize: '0.9em',
                              padding: '0px 6px',
                            }}
                            bsSize="small"
                          >
                            <option value="ABERTO">Aberto</option>
                            <option value="EM_ANDAMENTO">Em Andamento</option>
                            <option value="FINALIZADO">Finalizado</option>
                          </FormControl>
                          {originalTicketStatus !== editingTicketStatus && (
                            <Button
                              className="btn btn-success btn-xs"
                              icon={isSavingStatus ? 'spinner fa-spin' : 'save'}
                              onClick={this.handleSaveTicketStatus}
                              disabled={isSavingStatus}
                              title="Salvar Status"
                              style={{ lineHeight: '1.2', padding: '3px 8px' }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </Panel.Body>
                </Panel>

                <Panel bsStyle="default" className="interaction-panel" style={{ marginTop: '15px' }}>
                  <Panel.Heading>
                    <Panel.Title componentClass="h4" style={{ fontSize: '1.1em' }}>
                      Descrição Original
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body style={{ whiteSpace: 'pre-wrap' }}>
                    {currentTicketForInteractions.descricao || 'Nenhuma descrição fornecida.'}
                  </Panel.Body>
                </Panel>

                <div className="add-interaction-section">
                  <h4>Adicionar Nova Interação:</h4>
                  <FormGroup controlId="formNovaInteracao">
                    <FormControl
                      as="textarea"
                      rows={3}
                      value={newInteractionText}
                      onChange={this.handleNewInteractionChange}
                      placeholder="Digite sua observação ou resposta aqui..."
                      disabled={currentTicketInteractionsAdding}
                    />
                  </FormGroup>
                  {currentTicketInteractionsAddError && (
                    <p className="text-danger" style={{ marginTop: '5px' }}>
                      Falha ao adicionar interação. Tente novamente.
                    </p>
                  )}
                </div>

                <h4 style={{ marginTop: '20px', marginBottom: '15px' }}>Histórico de Interações:</h4>
                {interacoesLoading && (
                  <p className="text-center">
                    <i className="fa fa-spinner fa-spin" /> Carregando interações...
                  </p>
                )}
                {interacoesError && <p className="text-danger text-center">Erro ao carregar interações.</p>}
                {!interacoesLoading && !interacoesError && interacoesDoTicketAtual.length === 0 && (
                  <p className="text-muted text-center">Nenhuma interação registrada para este ticket ainda.</p>
                )}
                {!interacoesLoading && !interacoesError && interacoesDoTicketAtual.length > 0 && (
                  <div>
                    {[...interacoesDoTicketAtual]
                      .sort((a, b) => new Date(b.data_interacao) - new Date(a.data_interacao))
                      .map(interacao => (
                        <Panel
                          key={interacao.id}
                          className={`interaction-panel ${interacao.privado ? 'interaction-private' : ''}`}
                        >
                          <Panel.Heading className="interaction-panel-heading">
                            <small>
                              <strong>{interacao.nome_usuario || 'Usuário Desconhecido'}</strong> em{' '}
                              {new Date(interacao.data_interacao).toLocaleString('pt-BR', {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                                hour: '2-digit',
                                minute: '2-digit',
                              })}
                              {interacao.tipo_interacao && interacao.tipo_interacao !== 'COMENTARIO' && (
                                <span className="interaction-type-badge">{interacao.tipo_interacao}</span>
                              )}
                              {interacao.privado && (
                                <span className="interaction-private-badge">
                                  <i className="fa fa-lock" /> Privado
                                </span>
                              )}
                            </small>
                          </Panel.Heading>
                          <Panel.Body style={{ whiteSpace: 'pre-wrap' }}>{interacao.texto_interacao}</Panel.Body>
                        </Panel>
                      ))}
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer style={{ borderTop: '1px solid #e5e5e5', paddingTop: '15px' }}>
                <Button className="btn btn-default" onClick={this.handleCloseInteractionsModal} label="Fechar" />
                <Button
                  className="btn btn-primary"
                  icon={currentTicketInteractionsAdding ? 'spinner fa-spin' : 'plus'}
                  label={currentTicketInteractionsAdding ? 'Adicionando...' : 'Adicionar Interação'}
                  onClick={this.handleAddNewInteraction}
                  disabled={!newInteractionText.trim() || interacoesLoading || currentTicketInteractionsAdding}
                />
              </Modal.Footer>
            </Modal>
          )}
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  tickets: state.ticketSuporte.list,
  interacoesDoTicketAtual: state.ticketSuporte.currentTicketInteractions.data,
  interacoesLoading: state.ticketSuporte.currentTicketInteractions.loading,
  interacoesError: state.ticketSuporte.currentTicketInteractions.error,
  currentTicketInteractionsAdding: state.ticketSuporte.currentTicketInteractions.adding,
  currentTicketInteractionsAddError: state.ticketSuporte.currentTicketInteractions.addError,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchTickets,
      fetchInteracoes,
      addInteracao,
      updateTicket,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TicketSuporteList);
